// src/api/parkpassAuth.js
import ParkPassAPI from "./parkpassAxiosConfig";

export const exchangeExternalToken = async (externalToken) => {
  try {
    const response = await ParkPassAPI.post("/v1/auth/external-auth", {
      external_token: externalToken,
    });
    return response.data; // { access_token, expires_in, refresh_token }
  } catch (error) {
    throw error;
  }
};

export const refreshParkPassTokenAPI = async (refreshToken) => {
  try {
    const response = await ParkPassAPI.post("/v1/auth/refresh", {
      refresh_token: refreshToken,
    });
    return response.data; // { access_token, expires_in, refresh_token }
  } catch (error) {
    throw error;
  }
};
